import { lazy, Suspense, useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { AuthPage, WelcomePage } from './pages/Auth'
import { OnboardingGoals, OnboardingHand, OnboardingProfile, OnboardingTutorial } from './pages/Onboarding'
import { TodayPage } from './pages/Today'
import { AnalyzePage, MealCategoryPage, MealContextPage, MealPhotoPage, MealReviewPage, MealSourcePage } from './pages/MealFlow'
import { ActivityPage } from './pages/Activity'
import { MealDetailsPage } from './pages/MealDetails'
import { useMarlovaStore } from './store'

const HistoryPage = lazy(() => import('./pages/History').then((module) => ({ default: module.HistoryPage })))
const SettingsPage = lazy(() => import('./pages/Settings').then((module) => ({ default: module.SettingsPage })))

function LoadingRoute() {
  return <div className="route-loading" role="status"><span className="spin" />Loading Marlova…</div>
}

export function App() {
  const sessionChecked = useMarlovaStore((state) => state.sessionChecked)
  const bootstrapSession = useMarlovaStore((state) => state.bootstrapSession)
  useEffect(() => { if (!sessionChecked) void bootstrapSession() }, [bootstrapSession, sessionChecked])
  if (!sessionChecked) return <LoadingRoute />

  return (
    <Suspense fallback={<LoadingRoute />}>
      <Routes>
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/register" element={<AuthPage mode="register" />} />
        <Route path="/forgot-password" element={<AuthPage mode="forgot" />} />
        <Route path="/reset-password" element={<AuthPage mode="reset" />} />
        <Route path="/verify-email" element={<AuthPage mode="verify" />} />

        <Route element={<AppShell />}>
          <Route path="/onboarding/profile" element={<OnboardingProfile />} />
          <Route path="/onboarding/goals" element={<OnboardingGoals />} />
          <Route path="/onboarding/hand" element={<OnboardingHand />} />
          <Route path="/onboarding/tutorial" element={<OnboardingTutorial />} />
          <Route path="/today" element={<TodayPage />} />
          <Route path="/log/category" element={<MealCategoryPage />} />
          <Route path="/log/photo" element={<MealPhotoPage />} />
          <Route path="/log/source" element={<MealSourcePage />} />
          <Route path="/log/context" element={<MealContextPage />} />
          <Route path="/log/analyzing/:mealId" element={<AnalyzePage />} />
          <Route path="/log/review/:mealId" element={<MealReviewPage />} />
          <Route path="/meals/:mealId" element={<MealDetailsPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/activity/new" element={<ActivityPage />} />
          <Route path="/activity/:activityId/edit" element={<ActivityPage />} />
          <Route path="/settings/:section" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/welcome" replace />} />
      </Routes>
    </Suspense>
  )
}
